// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore";

const name = "pointCloudVertex";
const shader = ``;
// Sideeffect
if (!ShaderStore.IncludesShadersStoreWGSL[name]) {
    ShaderStore.IncludesShadersStoreWGSL[name] = shader;
}
/** @internal */
export const pointCloudVertexWGSL = { name, shader };
